document.addEventListener('DOMContentLoaded', () => {
    const thumbnailItems = document.querySelectorAll('.thumbnail-item img');
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightbox-image');
    const lightboxCaption = document.getElementById('lightbox-caption');
    const closeLightboxButton = document.querySelector('.close-lightbox');
    const prevLightboxButton = document.querySelector('.prev-lightbox');
    const nextLightboxButton = document.querySelector('.next-lightbox');

    let currentImageIndex = 0;
    const imagesData = [];

    // Daten aus den Thumbnails sammeln
    thumbnailItems.forEach((item, index) => {
        imagesData.push({
            src: item.src, // Verwende die src des Thumbnails, die von Parcel verarbeitet wird
            alt: item.alt,
            caption: item.nextElementSibling.textContent // Nimmt den Text aus dem folgenden <p> Element
        });

        item.addEventListener('click', () => {
            currentImageIndex = index;
            openLightbox();
        });
    });

    function openLightbox() {
        if (imagesData.length === 0 || currentImageIndex < 0 || currentImageIndex >= imagesData.length) {
            return;
        }
        const imageData = imagesData[currentImageIndex];
        lightboxImage.src = imageData.src;
        lightboxImage.alt = imageData.alt;
        lightboxCaption.textContent = imageData.caption;
        lightbox.style.display = 'block';
        // Einfache Überblendung (kann später verbessert werden)
        lightboxImage.style.opacity = 0;
        setTimeout(() => {
            lightboxImage.style.opacity = 1;
        }, 50); // Kurze Verzögerung für den Effekt
    }

    function closeLightbox() {
        lightbox.style.display = 'none';
    }

    function showPrevImage() {
        currentImageIndex = (currentImageIndex - 1 + imagesData.length) % imagesData.length;
        openLightbox();
    }

    function showNextImage() {
        currentImageIndex = (currentImageIndex + 1) % imagesData.length;
        openLightbox();
    }

    if (closeLightboxButton) {
        closeLightboxButton.addEventListener('click', closeLightbox);
    }
    if (prevLightboxButton) {
        prevLightboxButton.addEventListener('click', showPrevImage);
    }
    if (nextLightboxButton) {
        nextLightboxButton.addEventListener('click', showNextImage);
    }

    // Schließen der Lightbox bei Klick außerhalb des Bildes (optional)
    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) { // Nur wenn direkt auf den Hintergrund geklickt wird
            closeLightbox();
        }
    });

    // Tastaturnavigation (optional)
    document.addEventListener('keydown', (e) => {
        if (lightbox.style.display === 'block') {
            if (e.key === 'Escape') {
                closeLightbox();
            } else if (e.key === 'ArrowLeft') {
                showPrevImage();
            } else if (e.key === 'ArrowRight') {
                showNextImage();
            }
        }
    });
});